<template>
      <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
     <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
        <!-- 放在 <a-form-model> 与 </a-form-model> 之间即可 -->
<a-row :gutter="16">
  <!-- 到期时间 -->
  <a-col :span="24">
    <a-form-model-item label="到期时间" prop="expireTime" required>
      <a-date-picker
        v-model="form.expireTime"
        show-time
        format="YYYY-MM-DD HH:mm:ss"
        placeholder="请选择到期时间"
        style="width: 100%"
      />
    </a-form-model-item>
  </a-col>

  <!-- 存储溢出类型 -->
  <a-col :span="24">
    <a-form-model-item label="存储溢出类型" prop="overflowType" required>
      <a-select v-model="form.overflowType" placeholder="请选择存储溢出类型">
        <a-select-option :value="0">不允许超出存储</a-select-option>
        <a-select-option :value="1">允许超出存储</a-select-option>
      </a-select>
    </a-form-model-item>
  </a-col>

  <!-- 状态 -->
  <a-col :span="24">
    <a-form-model-item label="状态" prop="status" required>
      <a-radio-group v-model="form.status">
        <a-radio :value="1">有效</a-radio>
        <a-radio :value="0">禁用</a-radio>
      </a-radio-group>
    </a-form-model-item>
  </a-col>

  <!-- 分配容量 -->
  <a-col :span="24">
    <a-form-model-item label="分配容量(GB)" prop="totalCapacity" required>
      <a-input-number
        v-model="form.totalCapacity"
        :min="-1"
        :precision="2"
        placeholder="请输入分配容量，-1 表示无限"
        style="width: 100%"
      />
    </a-form-model-item>
  </a-col>

  <!-- 单位标识（选填） -->
  <a-col :span="24">
    <a-form-model-item label="单位标识" prop="tenantId">
      <a-input-number
        v-model="form.tenantId"
        :min="0"
        placeholder="请输入单位标识"
        style="width: 100%"
      />
    </a-form-model-item>
  </a-col>

  <!-- 备注（选填） -->
  <a-col :span="24">
    <a-form-model-item label="备注" prop="remark">
      <a-textarea
        v-model="form.remark"
        :rows="3"
        placeholder="请输入备注"
      />
    </a-form-model-item>
  </a-col>
</a-row>
    </a-form-model>
  </a-drawer>
</template>
<script>
export default {
  data() {
  return {
    open: false,
    form: {
      expireTime: null,        // 使用 moment 对象
      overflowType: undefined, // 0 | 1
      status: 1,               // 1 | 0
      totalCapacity: undefined,
      tenantId: undefined,
      remark: '',
    },
    rules: {
      expireTime: [
        { required: true, message: '请选择到期时间', trigger: 'change' },
      ],
      overflowType: [
        { required: true, message: '请选择存储溢出类型', trigger: 'change' },
      ],
      status: [
        { required: true, message: '请选择状态', trigger: 'change' },
      ],
      totalCapacity: [
        { required: true, message: '请输入分配容量', trigger: 'blur' },
        { type: 'number', message: '必须为数字' },
      ],
    },
  }
},
  methods: {
    onClose() {
      this.open = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
